import { Tabs } from 'antd'
import { useSearchParams } from 'react-router-dom'

import QuestionCoverage from './QuestionCoverage'
import QuestionList from './QuestionList'

export default function QuestionManagementPage() {
  const [searchParams, setSearchParams] = useSearchParams()
  const activeKey = searchParams.get('view') === 'coverage' ? 'coverage' : 'list'

  return (
    <main>
      <Tabs
        activeKey={activeKey}
        onChange={(key) => setSearchParams(key === 'coverage' ? { view: 'coverage' } : {})}
        items={[
          { key: 'list', label: '题目列表', children: <QuestionList /> },
          { key: 'coverage', label: '覆盖分析', children: <QuestionCoverage /> },
        ]}
      />
    </main>
  )
}
